import ChristmasOpeningHours from './ChristmasOpeningHours'

export default ChristmasOpeningHours
